import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./pages/Layout";
import Estetica from "./pages/Estetica";
import "./App.css";
//Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Estética landing pages */}
        <Route path="/landing" element={<Navigate to="/estetica" replace />} />
        <Route path="/estetica" element={<Estetica />} />

        {/* Original website routes */}
        <Route path="/*" element={<Layout />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
